import { makeStyles } from '@material-ui/core/styles';
export const useDefaultMethodStyle = makeStyles(theme => ({
    chooseDefaultMethodTitle: {
        //paddingTop: '34px',
        //paddingLeft: '168px',
        paddingBottom: '16px',
        fontFamily: theme.typography.subtitle2.fontFamily,
        fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: theme.typography.body3Medium.fontSize,
        lineHeight: '24px',
        color: theme.palette.primary.heather,
        [theme.breakpoints.down('xs')]: {
            fontSize: theme.typography.body1.fontSize,
            paddingBottom: '11px',
            marginLeft: '16px !important',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            paddingBottom: '11px',
            marginLeft: '16px !important',
        },
    },

    defaultMethodOptions: {
        //paddingLeft: '170px',
        //paddingRight: '150px',
    },

    directDebitParent: {
        paddingTop: '16px',
        //paddingLeft: '27px',
        //paddingRight: '16px',
        paddingBottom: '17px',
        marginBottom: '8px !important',
        borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            marginBottom: '6px !important',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginBottom: '6px !important',
        },
    },

    paymentMethod: {
        // background: 'white',
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '34px 150px 50px 168px',
        //padding: '30px 0',
        height: '100%',
        [theme.breakpoints.down('xs')]: {
            //padding: 16,
            padding: '39px 17px 258px 15px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            padding: '39px 17px 258px 15px',
        },
        '& *': {
            margin: 0,
        },
    },

    directDebitPlusMethod: {
        paddingLeft: '46.33px',
        paddingRight: '110px',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '28.33px',
            paddingRight: '35px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            paddingLeft: '28.33px',
            paddingRight: '35px',
        },
    },

    methodName: {
        //paddingTop: '16px',
        paddingBottom: '3px',
        //paddingLeft: '46.33px',
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: theme.typography.subtitle2.fontSize,
        // lineHeight: '16px',
        color: theme.palette.primary.heather,
        [theme.breakpoints.down('xs')]: {
            fontSize: theme.typography.overline.fontSize,
            //paddingLeft: '28.33px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {},
    },

    setupMethodName: {
        //paddingBottom: '17px',
        //paddingLeft: '46.33px',
        fontFamily: theme.typography.body2.fontFamily,
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '20px',
        color: theme.palette.primary.heather,
        [theme.breakpoints.down('xs')]: {
            fontSize: theme.typography.overline.fontSize,
            //paddingLeft: '28.33px',
        },
    },

    debitIcon: {
        background: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_112_22760)'%3E%3Cpath d='M12.0002 23.8303C5.52023 23.8303 0.240234 18.5603 0.240234 12.0703C0.240234 5.58031 5.52023 0.320312 12.0002 0.320312C18.4802 0.320312 23.7602 5.59031 23.7602 12.0803C23.7602 18.5703 18.4902 23.8403 12.0002 23.8403V23.8303ZM12.0002 1.73031C6.30023 1.73031 1.66023 6.37031 1.66023 12.0703C1.66023 17.7703 6.30023 22.4103 12.0002 22.4103C17.7002 22.4103 22.3402 17.7703 22.3402 12.0703C22.3402 6.37031 17.7002 1.73031 12.0002 1.73031Z' fill='%23DD1D78'/%3E%3Cpath d='M11.03 16.5099C10.48 16.2499 10.04 15.8699 9.68004 15.3699C9.33004 14.8699 9.08004 14.2799 8.94004 13.5899H7.79004V12.7199H8.82004C8.81004 12.5299 8.80004 12.3399 8.80004 12.1399C8.80004 11.8799 8.80004 11.6499 8.83004 11.4599H7.79004V10.5999H8.96004C9.19004 9.58988 9.64004 8.79988 10.32 8.22988C11 7.66988 11.86 7.37988 12.9 7.37988C13.71 7.37988 14.39 7.50988 14.94 7.77988V8.91988C14.38 8.58988 13.74 8.41988 13.01 8.41988C12.34 8.41988 11.76 8.58988 11.28 8.93988C10.8 9.28988 10.46 9.83988 10.27 10.5899H13.39V11.4499H10.13C10.11 11.6399 10.1 11.8699 10.1 12.1299C10.1 12.3299 10.1 12.5199 10.12 12.7099H13.39V13.5799H10.25C10.44 14.3699 10.77 14.9399 11.25 15.3099C11.73 15.6699 12.32 15.8599 13.01 15.8599C13.75 15.8599 14.39 15.6899 14.94 15.3599V16.4999C14.39 16.7699 13.71 16.8999 12.9 16.8999C12.2 16.8999 11.57 16.7699 11.03 16.5099Z' fill='%23DD1D78'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_112_22760'%3E%3Crect width='24' height='24' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A")`,
        maxWidth: '24px',
        height: '24px',
        display: 'inline-block',
        position: 'relative',
        marginLeft: '27px',
        marginTop: '7px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '19px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginLeft: '19px',
        },
    },

    creditIcon: {
        background: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.3153 5H19.0947H20.6847C21.3254 5 21.9035 5.26629 22.3218 5.69559C22.7404 6.1246 23 6.71753 23 7.37466L23 16.6253C23 17.2825 22.7404 17.8754 22.3218 18.3044C21.9035 18.7337 21.3254 19 20.6847 19L19.0947 19L19.0938 19L3.3153 19C2.5593 19 1.88845 18.6238 1.466 18.0449C1.17644 17.6516 1.00326 17.1625 1.00005 16.6309L1 16.6253V16.6158V7.3842V7.37466L1.00005 7.36911C1.00326 6.83746 1.17644 6.34845 1.466 5.95514C1.88845 5.37619 2.5593 5 3.3153 5ZM21.6796 11.2402V16.6253C21.6796 17.188 21.2333 17.6458 20.6847 17.6458L5.63146 17.6458L5.6306 17.6458L3.3153 17.6458C2.76669 17.6458 2.32037 17.188 2.32037 16.6253L2.32037 11.2402H21.6796ZM21.6796 9.74023V7.37466C21.6796 6.81199 21.2333 6.35422 20.6847 6.35422L5.63153 6.35422L5.6306 6.35422H3.3153C2.76669 6.35422 2.32037 6.81199 2.32037 7.37466L2.32037 9.74023H21.6796Z' fill='%23DD1D77'/%3E%3C/svg%3E ")`,
        maxWidth: '24px',
        height: '24px',
        display: 'inline-block',
        position: 'relative',
        marginLeft: '25px',
        marginTop: '8px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '16px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginLeft: '16px',
        },
    },

    sepaIcon: {
        background: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_112_41580)'%3E%3Cpath d='M4.18005 8.02344H17.0237' stroke='%23DD1D77' stroke-width='1.43359'/%3E%3Cpath d='M4.18005 12.2549H17.0237' stroke='%23DD1D77' stroke-width='1.43359'/%3E%3C/g%3E%3Cpath d='M17.1046 9.87538C17.1046 13.3798 14.2339 16.2332 10.6773 16.2332C7.12071 16.2332 4.25 13.3798 4.25 9.87538C4.25 6.37093 7.12071 3.51758 10.6773 3.51758C14.2339 3.51758 17.1046 6.37093 17.1046 9.87538Z' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M3.97784 15.6626C5.5979 17.6505 8.06578 18.9201 10.8302 18.9201C15.7097 18.9201 19.6653 14.9645 19.6653 10.0851C19.6653 5.2056 15.7097 1.25 10.8302 1.25C9.98441 1.25 9.16639 1.36885 8.39191 1.59075' stroke='%23DD1D77' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10.668 19.0146V22.5986' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M7.32294 22.8379H14.013' stroke='%23DD1D77' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M12.9493 9.87546C12.9493 11.717 12.6233 13.3483 12.1264 14.4913C11.8774 15.0639 11.6003 15.48 11.3306 15.7423C11.0645 16.0012 10.8448 16.0761 10.6773 16.0761C10.5098 16.0761 10.2901 16.0012 10.024 15.7423C9.75432 15.48 9.47719 15.0639 9.22821 14.4913C8.73127 13.3483 8.40527 11.717 8.40527 9.87546C8.40527 8.03397 8.73127 6.40259 9.22821 5.25965C9.47719 4.687 9.75432 4.27092 10.024 4.00861C10.2901 3.7497 10.5098 3.6748 10.6773 3.6748C10.8448 3.6748 11.0645 3.7497 11.3306 4.00861C11.6003 4.27092 11.8774 4.687 12.1264 5.25965C12.6233 6.40259 12.9493 8.03397 12.9493 9.87546Z' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cg clip-path='url(%23clip1_112_41580)'%3E%3Cpath d='M4.18005 8.02344H17.0237' stroke='%23DD1D77' stroke-width='1.43359'/%3E%3Cpath d='M4.18005 12.2549H17.0237' stroke='%23DD1D77' stroke-width='1.43359'/%3E%3C/g%3E%3Cpath d='M17.1046 9.87538C17.1046 13.3798 14.2339 16.2332 10.6773 16.2332C7.12071 16.2332 4.25 13.3798 4.25 9.87538C4.25 6.37093 7.12071 3.51758 10.6773 3.51758C14.2339 3.51758 17.1046 6.37093 17.1046 9.87538Z' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M3.97784 15.6626C5.5979 17.6505 8.06578 18.9201 10.8302 18.9201C15.7097 18.9201 19.6653 14.9645 19.6653 10.0851C19.6653 5.2056 15.7097 1.25 10.8302 1.25C9.98441 1.25 9.16639 1.36885 8.39191 1.59075' stroke='%23DD1D77' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10.668 19.0146V22.5986' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M7.32294 22.8379H14.013' stroke='%23DD1D77' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M12.9493 9.87546C12.9493 11.717 12.6233 13.3483 12.1264 14.4913C11.8774 15.0639 11.6003 15.48 11.3306 15.7423C11.0645 16.0012 10.8448 16.0761 10.6773 16.0761C10.5098 16.0761 10.2901 16.0012 10.024 15.7423C9.75432 15.48 9.47719 15.0639 9.22821 14.4913C8.73127 13.3483 8.40527 11.717 8.40527 9.87546C8.40527 8.03397 8.73127 6.40259 9.22821 5.25965C9.47719 4.687 9.75432 4.27092 10.024 4.00861C10.2901 3.7497 10.5098 3.6748 10.6773 3.6748C10.8448 3.6748 11.0645 3.7497 11.3306 4.00861C11.6003 4.27092 11.8774 4.687 12.1264 5.25965C12.6233 6.40259 12.9493 8.03397 12.9493 9.87546Z' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M4.17999 8H17.0236' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M4.17999 12.2314H17.0236' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M17.1046 9.87538C17.1046 13.3798 14.2339 16.2332 10.6773 16.2332C7.12071 16.2332 4.25 13.3798 4.25 9.87538C4.25 6.37093 7.12071 3.51758 10.6773 3.51758C14.2339 3.51758 17.1046 6.37093 17.1046 9.87538Z' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M3.97784 15.6626C5.5979 17.6505 8.06578 18.9201 10.8302 18.9201C15.7097 18.9201 19.6653 14.9645 19.6653 10.0851C19.6653 5.2056 15.7097 1.25 10.8302 1.25C9.98441 1.25 9.16639 1.36885 8.39191 1.59075' stroke='%23DD1D77' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10.668 19.0146V22.5986' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cpath d='M7.32294 22.8379H14.013' stroke='%23DD1D77' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M12.9493 9.87546C12.9493 11.717 12.6233 13.3483 12.1264 14.4913C11.8774 15.0639 11.6003 15.48 11.3306 15.7423C11.0645 16.0012 10.8448 16.0761 10.6773 16.0761C10.5098 16.0761 10.2901 16.0012 10.024 15.7423C9.75432 15.48 9.47719 15.0639 9.22821 14.4913C8.73127 13.3483 8.40527 11.717 8.40527 9.87546C8.40527 8.03397 8.73127 6.40259 9.22821 5.25965C9.47719 4.687 9.75432 4.27092 10.024 4.00861C10.2901 3.7497 10.5098 3.6748 10.6773 3.6748C10.8448 3.6748 11.0645 3.7497 11.3306 4.00861C11.6003 4.27092 11.8774 4.687 12.1264 5.25965C12.6233 6.40259 12.9493 8.03397 12.9493 9.87546Z' stroke='%23DD1D77' stroke-width='1.5'/%3E%3Cdefs%3E%3CclipPath id='clip0_112_41580'%3E%3Crect width='12.9947' height='5.43964' fill='white' transform='translate(4.02887 7.15527)'/%3E%3C/clipPath%3E%3CclipPath id='clip1_112_41580'%3E%3Crect width='12.9947' height='5.43964' fill='white' transform='translate(4.02887 7.15527)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A")`,
        maxWidth: '24px',
        height: '24px',
        display: 'inline-block',
        position: 'relative',
        marginLeft: '27px',
        marginTop: '2px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '19px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginLeft: '19px',
        },
    },

    arrowIcon: {
        background: `url("data:image/svg+xml,%3Csvg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 10.6L1.4 12L7.4 6L1.4 0L0 1.4L4.6 6L0 10.6Z' fill='%23DD1D77'/%3E%3C/svg%3E%0A")`,
        maxWidth: '7.4px',
        height: '12px',
        display: 'inline-block',
        position: 'relative',
        marginTop: '12px',
    },
}));
